/**
 * Kit secondary name gates for ControlsReagentsModal.
 * Shared with unit tests so Save-disable and empty-kit messaging stay aligned.
 */

export interface SecondaryNameRow {
  name: string
}

export const trimmedSecondaryName = (row: SecondaryNameRow): string => row.name.trim()

export const hasBlankSecondaryName = (params: {
  isKit: boolean
  secondaryLots: SecondaryNameRow[]
}): boolean =>
  params.isKit && params.secondaryLots.some((row) => trimmedSecondaryName(row).length === 0)

export const hasNamedSecondary = (secondaryLots: SecondaryNameRow[]): boolean =>
  secondaryLots.some((row) => trimmedSecondaryName(row).length > 0)

export const kitMissingSecondary = (params: {
  isKit: boolean
  secondaryLots: SecondaryNameRow[]
}): boolean => params.isKit && !hasNamedSecondary(params.secondaryLots)

export const kitSecondaryBlocksSubmit = (params: {
  isKit: boolean
  secondaryLots: SecondaryNameRow[]
}): boolean => kitMissingSecondary(params) || hasBlankSecondaryName(params)

export const secondaryNameMissing = (params: { isKit: boolean; name: string }): boolean =>
  params.isKit && trimmedSecondaryName({ name: params.name }).length === 0
